import {
  getCompleteDataFormValues,
  getQuotation,
  getUserData,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  MessagesEnum,
  ModelPathEnum,
} from 'app/shared/enums';
import checkIfPeselIsMatchingLicenseDate from 'app/services/businessFunctions/helpers/checkIfPeselIsMatchingLicenseDate';
import { setFamilyNameVisibility } from 'app/services/businessFunctions/helpers/setFamilyNameVisibility';
import { isPeselValid } from 'app/services/pesel.service';
import { CompletePersonData } from 'app/shared/interfaces/CompleteFormDataByKeys.interface';

function getPesel() {
  const completeDataFormValues = getCompleteDataFormValues();

  if (
    !completeDataFormValues.coowners ||
    !completeDataFormValues.coowners[1] ||
    !(completeDataFormValues.coowners[1] as CompletePersonData).pesel
  ) {
    return;
  }

  return (completeDataFormValues.coowners[1] as CompletePersonData)
    .pesel as string;
}

const firstCoownerDetails = {
  completeDataFormCoowners1PeselChange() {
    const pesel = getPesel();

    if (!pesel) {
      return;
    }

    const coowners = getQuotation().coOwners || [];
    const coowners1 = coowners[0] || {
      driverLicenseIssuedYear: 0,
      driverLicenseIssuedMonth: 0,
    };
    const driverLicenseYear = coowners1.driverLicenseIssuedYear;
    const driverLicenseMonth = coowners1.driverLicenseIssuedMonth;

    checkIfPeselIsMatchingLicenseDate({
      pesel,
      driverLicenseYear,
      driverLicenseMonth,
      noDriverLicenseModelPath: ModelPathEnum.Coowners1NoDriverLicense,
      messageKey:
        MessagesEnum.CompleteDataFormCoowners1PeselAndLicenseYearMismatch,
      formName: FormsEnum.CompleteDataForm,
    });
  },

  completeDataFormCoowners1CheckIfPeselIsMatchingGender() {
    const { coOwners } = getQuotation();
    const isOperator = getUserData().user?.operator;
    const pesel = getPesel();
    const genderNotSet = !coOwners || !coOwners[0] || !coOwners[0].gender;

    if (!pesel || genderNotSet || !isOperator) {
      return;
    }

    setFamilyNameVisibility(
      FieldsEnum.CompleteDataCoowners1FamilyName,
      FormsEnum.CompleteDataForm,
      pesel,
      isPeselValid(pesel)
    );
  },
};

export default firstCoownerDetails;
